import { FormElement, Form } from '@progress/kendo-react-form'
import SaveButton from 'components/Buttons/SaveButton/SaveButton'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { focusFirstError } from 'core/helpers'
import { useRef } from 'react'
import { Col, Row } from 'react-bootstrap'

interface IProps {
    editable: boolean
    formIsModified: boolean
}

const ContactsForm = ({ editable }: IProps) => {


    return (
        <div id='ContactsForm'>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light shadow-sm p-3 border pb-5'>
                            <Row>
                                <Col md={6}><h4>Contacts</h4></Col>
                                <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}>
                                    {/* place right aligned element here if needed */}
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs={12}>
                                    Content here
                                </Col>
                            </Row>
                        </div>
                        <Row className='my-4'>
                            <Col xs={12} sm={4}>
                                <SaveButton
                                    title={!editable ? DEFAULT_PERMISSION_MESSAGE : undefined}
                                    onClick={() => focusFirstError(formRenderProps)}
                                    type='submit' />
                            </Col>
                        </Row>

                    </FormElement>

                )
                }
            />
        </div>
    )
}
export default ContactsForm

